<body>


    <!--==========================
    Intro Section
  ============================-->
    <section id="intro" class="clearfix">
        <div class="container">
            <div class="d-flex align-items-center justify-content-between">
         

            <div class="intro-info">
                <div class="navigation">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb" style="background-color:#00339900 !important;">
                            <li class="breadcrumb-item" ><a style="color: white ;" [routerLink]="['/inicio']">Inicio</a></li>
                            <li class="breadcrumb-item cursorActivo"><a style="color: white ;" [routerLink]="['/ofertaAcademica']">Oferta Académica</a></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: white ;" >Ficha Admisión</li>

                        </ol>
                    </nav>
                </div>
                
                <h2>Universidad Nacional Autónoma de Honduras</h2>

                <div
                    style="letter-spacing: -0.025em !important; font-weight: 500 !important; color: white; font-size: 25px;">
                    Dirección del sistema de estudios de posgrado
                </div>

               

            </div>

            <div class="intro-img d-none d-md-block">
                <img src="../../assets/images/BackGround/DSEPUNAH.PNG" alt="" class="img-fluid">
            </div>
        </div>
        </div>
    </section>
    <div class="intro-gold-bar"></div>
    <!-- #intro -->

    <main id="main">

        <!--==========================
      About Us Section
    ============================-->
        <section id="about" *ngIf="!solicitudEnviada">

            <div class="row lisp">
                <mat-list class="col-md-6">
                    <mat-list-item>
                        <mat-icon mat-list-icon>foundation</mat-icon>
                        <div mat-line class="font"> <b>Centro:</b> </div>
                        <!-- <div mat-line class="font">{{datosCarrera.centro}}</div> -->
                        <div mat-line class="font">{{centroVirtual}}</div>
                    </mat-list-item>
                </mat-list>

                <mat-list class="col-md-6">
                    <!-- <mat-list-item>
                        <mat-icon mat-list-icon>menu_book</mat-icon>
                        <div mat-line class="font"><b>Posgrado:</b> </div>
                        <div mat-line class="font">{{datosCarrera.nombrePosgrado}}, modalidad: ({{datosCarrera.modalidad}})</div>
                    </mat-list-item> -->
                    <mat-list-item class="posgrado-item">
                        <mat-icon mat-list-icon>menu_book</mat-icon>
                        <div class="font" style="display: flex; flex-direction: column; font-size: 14px;">
                          <span mat-line  style="font-weight: bold;"  class="font"><b>Posgrado:</b></span>
                          <span   class="font">{{datosCarrera.nombrePosgrado}}, modalidad: ({{datosCarrera.modalidad}})</span>
                        </div>
                      </mat-list-item>
                </mat-list>


            </div>

            <div class="container mt-4">

                <header class="section-header">
                    <h3>Solicitud de admisión</h3>
                    

                    <!-- <p>La Universidad Nacional Autónoma de Honduras (UNAH) pone a disposición de la comunidad universitaria y sociedad en general el presente sitio web con el objetivo de brindar respuesta a los trámites que se realizan en modo presencial
                        en los centros universitarios.</p> -->
                </header>



            </div>


            <mat-horizontal-stepper [selectable]="true" #stepper [linear]="true">
            
                <mat-step label="Datos Personales"  state="personal" [stepControl]="datosPersonalesForm">
                    <mat-card>
                        <mat-card-content >
                            <div class="form-section-title">
                                Información personal
                            </div>
                            <form [formGroup]="datosPersonalesForm">
                                <div class="row" style="font-size: 0.9rem;">
                                    <div style="margin-left: -15px !important;" class="col-lg-12 col-md-12 col-sm-12">
                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-3" style="margin-bottom: 15px !important;" *ngIf="eleccion !== 0 && eleccion !== 3">
                                        <mat-label>Número de cuenta</mat-label>
                                        <input   autocomplete="off" matInput placeholder="Número de cuenta"
                                            formControlName="noCuenta"  (keypress)="validateCuenta($event)"  (paste)="validateCuenta($event)">
                                        <!-- <mat-hint > Completar este campo solo si es egresado de la UNAH</mat-hint> -->
                                    </mat-form-field>
                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-3" style="margin-bottom: 15px !important;" *ngIf="eleccion !== 0 ">
                                        <mat-label>Correo institucional</mat-label>
                                        <input type="email"  autocomplete="off" matInput placeholder="Correo institucional"
                                            formControlName="CorreoInstitucional"  >
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-3">
                                        <mat-label>Tipo de identificación</mat-label>
                                        <mat-select formControlName="idTipoIdentificacion" required >
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table0" value="{{item.idTipoIdentificacion}}" >
                                                {{item.tipoIdentificacion}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="datosPersonalesForm.get('idTipoIdentificacion')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-3">
                                        <mat-label>Número de identificación</mat-label>
                                        <input autocomplete="off" type="text" id="numeroInput" name="numeroInput" matInput placeholder="Número de identificación" (keydown.enter)="$event.preventDefault()"
                                            (keypress)="validateFormat($event)"
                                            maxlength="20"
                                            formControlName="noIdentificacion" required>
                                            <mat-error *ngIf="datosPersonalesForm.get('noIdentificacion')?.hasError('required')">
                                                Este campo es obligatorio.
                                            </mat-error>
                                    </mat-form-field>
</div>
                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Primer nombre</mat-label>
                                        <input autocomplete="off" matInput placeholder="Primer nombre"
                                            (keypress)="validateFormatName($event)"
                                            formControlName="primerNombre" required>
                                            <mat-error *ngIf="datosPersonalesForm.get('primerNombre')?.hasError('required')">
                                                Este campo es obligatorio.
                                              </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Segundo nombre</mat-label>
                                        <input autocomplete="new-password" readonly (focus)="quitarReadonly($event)" matInput placeholder="Segundo nombre"
                                            (keypress)="validateFormatName($event)"
                                            formControlName="segundoNombre">
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4" style="margin-bottom: 2px !important;">
                                        <mat-label>Primer apellido</mat-label>
                                        <input autocomplete="off" matInput placeholder="Primer apellido"
                                            (keypress)="validateFormatName($event)"
                                            formControlName="primerApellido" required>
                                            <mat-error *ngIf="datosPersonalesForm.get('primerApellido')?.hasError('required')">
                                                Este campo es obligatorio.
                                            </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Segundo apellido</mat-label>
                                        <input autocomplete="new-password" readonly (focus)="quitarReadonly($event)" matInput placeholder="Segundo apellido"
                                            (keypress)="validateFormatName($event)"
                                            formControlName="segundoApellido">
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Género</mat-label>
                                        <mat-select formControlName="sexo" required>
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table1" value="{{item.id}}" >
                                                {{item.nombreGenero}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="datosPersonalesForm.get('sexo')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Estado civil</mat-label>
                                        <mat-select formControlName="idEstadoCivil" required>
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table2" value="{{item.id}}" >
                                                {{item.nombreEstadoCivil}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="datosPersonalesForm.get('idEstadoCivil')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4" >
                                        <mat-label>Fecha de nacimiento</mat-label>
                                        <input  matInput autocomplete="off"  formControlName="fechaNacimiento" type="date" [disabled]="true"    
                                         min="1940-01-01"
                                         (keydown)="preventTyping($event)"
                                          (keypress)="preventTyping($event)"
                                        [max]="fechaMaxima" required>
                                        <mat-error *ngIf="datosPersonalesForm.get('fechaNacimiento')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                </div>

                                <div class="row" style="font-size: 0.9rem;">


                                    <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                        <mat-label>Lugar de nacimiento</mat-label>
                                        <input autocomplete="off" matInput placeholder="Lugar de nacimiento" formControlName="lugarNaciemiento" required>
                                        <mat-error *ngIf="datosPersonalesForm.get('lugarNaciemiento')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                        <mat-label>País de nacionalidad</mat-label>
                                        <mat-select formControlName="idNacionalidad" required>
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table3" value="{{item.id}}" >
                                                {{item.nombrePais}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error *ngIf="datosPersonalesForm.get('idNacionalidad')?.hasError('required')">
                                            Este campo es obligatorio.
                                        </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                        <mat-label>Dirección de residencia</mat-label>
                                        <input autocomplete="off" matInput formControlName="direccionResidencia"
                                            required>
                                            <mat-error *ngIf="datosPersonalesForm.get('direccionResidencia')?.hasError('required')">
                                                Este campo es obligatorio.
                                            </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                        <mat-label>Grupo étnico</mat-label>
                                        <mat-select formControlName="idGrupoEtnico" >
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table9" value="{{item.id}}" >
                                                {{item.nombreGrupoEtnico}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>

                                    <!-- <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>País Origen</mat-label>
                                        <mat-select formControlName="idPaisOrigen" required>
                                            <mat-option value="option">Option</mat-option>
                                        </mat-select>
                                    </mat-form-field> -->

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Discapacidad</mat-label>
                                        <mat-select formControlName="idTipoDiscapacidad">
                                            <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table10" value="{{item.id}}" >
                                                {{item.nombreTipoDiscapacidad}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>





                                </div>
                                <div class="form-section-title mt-section">
                                    Información de contacto
                                </div>

                                <div class="row" style="font-size: 0.9rem;">
                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Correo electrónico</mat-label>
                                        <input  matInput type="email" autocomplete="new-password" readonly (focus)="quitarReadonly($event)" formControlName="correoElectronico" required (paste)="$event.preventDefault()" placeholder="ejemplo@correo.com">
                                          <mat-hint align="start">
                                            Asegúrese de ingresar un correo al que tenga acceso.
                                          </mat-hint>
                                        <mat-error *ngIf="datosPersonalesForm.get('correoElectronico')?.hasError('required')">
                                          Este campo es obligatorio.
                                        </mat-error>
                                        <mat-error *ngIf="datosPersonalesForm.get('correoElectronico')?.hasError('pattern')">
                                          Formato de correo inválido.
                                        </mat-error>
                                      </mat-form-field>
                                      
                                      <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Confirmar correo electrónico</mat-label>
                                        <input matInput type="email" autocomplete="new-password" readonly (focus)="quitarReadonly($event)"  formControlName="confirmarCorreo"  required (paste)="$event.preventDefault()" placeholder="Confirme su correo">
                                          <mat-error *ngIf="datosPersonalesForm.get('confirmarCorreo')?.hasError('required')">
                                            Este campo es obligatorio.
                                          </mat-error>
                                          <mat-error *ngIf="datosPersonalesForm.hasError('correosNoCoinciden')">
                                            Los correos no coinciden.
                                          </mat-error>
                                      </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Teléfono celular</mat-label>
                                        <input  autocomplete="off" matInput formControlName="celularContacto" 
                                            required  (keypress)="validateCel($event)"  (paste)="validateCel($event)">
                                            <mat-error *ngIf="datosPersonalesForm.get('celularContacto')?.hasError('required')">
                                                Este campo es obligatorio.
                                            </mat-error>
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Teléfono residencia</mat-label>
                                        <input  autocomplete="off" matInput
                                            formControlName="telefonoCasaContacto"  (keypress)="validateCel($event)"  (paste)="validateCel($event)">
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Teléfono oficina</mat-label>
                                        <input  autocomplete="off" matInput
                                            formControlName="telefonoOficinaContacto"  (keypress)="validateCel($event)"  (paste)="validateCel($event)">
                                    </mat-form-field>

                                    <mat-form-field appearance="legacy" class="col-lg-3 col-md-3 col-sm-4">
                                        <mat-label>Teléfono alternativo</mat-label>
                                        <input  autocomplete="off" matInput
                                            formControlName="telefonoAlternativo"  (keypress)="validateCel($event)"  (paste)="validateCel($event)">
                                    </mat-form-field>
                                </div>

                                <div class="step-footer step-footer--end">
                                    <button mat-raised-button matStepperNext class="btn-siguiente"
                                        (click)="confirmarDatosGenerales()">
                                        Siguiente
                                        <mat-icon>arrow_forward</mat-icon>
                                    </button>
                                </div>
                            </form>
                        </mat-card-content>

                    </mat-card>

                </mat-step>
                <mat-step label="Datos Académicos"  state="academico" >
                    
                    <mat-card>

                        <mat-card-content>
                            <div class="form-section-title">
                                Información de educación superior
                            </div>
                            <form [formGroup]="datosAcademicosForm">
                                
                            <button class="button-principal mt-2" mat-raised-button
                                (click)="educacionSuperiorModal(EducacionTemplate)">
                                <mat-icon style="color: white;">add</mat-icon>
                                Agregar Formación
                            </button>
                           
                            <div class="mt-2" style="font-size: 0.8rem;">
                                <p style="margin-bottom: 0px !important;">Presione "Agregar Formación" para poder
                                    ingresar los datos solicitados.</p>
                                <div class="table-responsive">

                                    <table class="table table-striped bordeTabla tablep" role="table">
                                        <thead class="theadp">

                                            <tr class="trp bg-success text-center">
                                                <th class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader" >Grado académico</th>
                                                <th class="thp" scope="col" role="columnheader">Título</th>
                                                <th class="thp" scope="col" role="columnheader">Institución</th>
                                                <th class="thp" scope="col" role="columnheader">Año en que egresó
                                                </th>
                                                <th class="thp" scope="col" role="columnheader">Índice de graduación
                                                </th>
                                                <th class="thp" scope="col" role="columnheader">Duración de estudios
                                                </th>
                                            </tr>
                                        </thead>


                                        <tbody role="rowgroup" class="tbodyp" *ngIf="contadorEducacion <= 3">
                                           
                                            <tr class="text-center trp" role="row" *ngFor="let academico of datosAcademicos; let i = index" >   
                                                <td role="cell" data-title="" class="tdp">
                                                    <button mat-mini-fab (click)="eliminarEducacionSuperior(academico)" class="btn-delete" matTooltip="Borrar"  matTooltipPosition="below">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                    <button mat-mini-fab (click)="editarEducacionSuperior(academico, i)" class="btn-edit" matTooltip="Editar"  matTooltipPosition="below">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                                <td role="cell" data-title="Grado académico" class="tdp" >
                                                    {{academico.nombreGradoAcademico }}</td>
                                                <td role="cell" data-title="Título" class="tdp" >
                                                    {{academico.titulo}}</td>
                                                <td role="cell" data-title="Institución" class="tdp">
                                                    {{academico.nombreInstitucion}}</td>
                                                <td role="cell" data-title="Año en que egresó" class="tdp">
                                                    {{academico.anoGraducion}}</td>
                                                <td role="cell" data-title="Indice graduación" class="tdp">
                                                    {{academico.indiceGraduacion }}</td>
                                                <td role="cell" data-title="Duración de estudios" class="tdp">
                                                    {{academico.duracionEstudio }}</td>


                                               
                                            </tr>
                                    
                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="form-section-title mt-section">
                                Idiomas
                            </div>

                            <button class="button-principal mt-2" mat-raised-button
                                (click)="idiomaModal(IdiomaTemplate)">
                                <mat-icon  style="color: white;">add</mat-icon>
                                Agregar Idioma
                            </button>


                            <div class="mt-2" style="font-size: 0.8rem;">
                                <p style="margin-bottom: 0px !important;">Presione "Agregar Idioma" para poder ingresar
                                    los datos solicitados. (Máximo 3)</p>
                                <div class="table-responsive">

                                    <table class="table table-striped bordeTabla tablep" role="table">
                                        <thead class="theadp">

                                            <tr class="trp bg-success text-center">
                                                <th  style="display: none;" class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader">Idioma</th>
                                                <th class="thp" scope="col" role="columnheader">Comprende</th>
                                                <th class="thp" scope="col" role="columnheader">Habla</th>
                                                <th class="thp" scope="col" role="columnheader">Lee</th>
                                                <th class="thp" scope="col" role="columnheader">Escribe</th>
                                            </tr>
                                        </thead>


                                        <tbody role="rowgroup" class="tbodyp" *ngIf="contador <= 3"  id="tableBody">
                                            
                                            <tr class="text-center trp" role="row" *ngFor="let item of lenguaje; let indiceI = index" >
                                                <td  style="display: none;">{{ indiceI}}</td>
                                                <td role="cell" data-title="" class="tdp" >
                                                    <button mat-mini-fab (click)="eliminarLenguaje(item,indiceI)" class="btn-delete" matTooltip="Borrar"  matTooltipPosition="below">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                    <button mat-mini-fab (click)="editarLenguaje(item, indiceI)" class="btn-edit" matTooltip="Editar"  matTooltipPosition="below">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                          
                                                <td role="cell" data-title="Idioma " class="tdp">
                                                    {{item.idioma}}</td>
                                                <td role="cell" data-title="Comprende" class="tdp">{{item.nombreComprende}}
                                                </td>
                                                <td role="cell" data-title="Habla" class="tdp">{{item.nombrehabla}}</td>
                                                <td role="cell" data-title="Lee" class="tdp">{{item.nombreLee }}</td>
                                                <td role="cell" data-title="Escribe" class="tdp">{{item.nombreEscribe }}</td>
                                                
                                            
                                            </tr>
                                        </tbody>
                                        
                                    </table>

                                </div>
                            </div>

                            <div class="form-section-title mt-section">
                                Otros Estudios
                            </div>
                            <p  style="font-size: 0.8rem;">Diplomados, capacitaciones o cursos más recientes</p>

                            <button class="button-principal mt-2" mat-raised-button
                                (click)="otrosEstudiosModal(OtrosEstudiosTemplate)">
                                <mat-icon  style="color: white;">add</mat-icon>
                                Agregar Otros Estudios
                            </button>


                            <div class="mt-2" style="font-size: 0.8rem;" >
                                <p style="margin-bottom: 0px !important;">Presione "Agregar Otros Estudios" para poder ingresar
                                    los datos solicitados. (Máximo 3)</p>
                                <div class="table-responsive">

                                    <table class="table table-striped bordeTabla tablep" role="table">
                                        <thead class="theadp">

                                            <tr class="trp bg-success text-center">
                                                <th  style="display: none;" class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader">Tipo de estudio</th>
                                                <th class="thp" scope="col" role="columnheader">Título</th>
                                                <th class="thp" scope="col" role="columnheader">Institución</th>
                                                <th class="thp" scope="col" role="columnheader">Año</th>
                                            </tr>
                                        </thead>


                                        <tbody role="rowgroup" class="tbodyp" *ngIf="contador <= 3">

                                            <tr class="text-center trp" role="row" *ngFor="let item of diplomadoArray; let indiceE = index">
                                                <td  style="display: none;">{{ indiceE}}</td>
                                                <td role="cell" data-title="" class="tdp">
                                                    <button mat-mini-fab (click)="eliminarEstudios(item,indiceE)" class="btn-delete" matTooltip="Borrar"  matTooltipPosition="below">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                    <button mat-mini-fab (click)="editarEstudios(item, indiceE)" class="btn-edit" matTooltip="Editar"  matTooltipPosition="below">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                                <td role="cell" data-title="Tipo de estudio" class="tdp">{{item.nombreTipoEstudio}}</td>
                                                <td role="cell" data-title="Título" class="tdp">{{item.titulo}}
                                                </td>
                                                <td role="cell" data-title="Institución" class="tdp">{{item.institucion}}</td>
                                                <td role="cell" data-title="Año" class="tdp">{{item.anoObtencion }}</td>

                                            </tr>

                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="step-footer">
                                <button mat-button matStepperPrevious class="btn-volver">
                                    <mat-icon>arrow_back</mat-icon>
                                    Volver
                                </button>
                                <button mat-raised-button matStepperNext class="btn-siguiente"
                                    (click)="confirmarDatosAcademicos()">
                                    Siguiente
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            </div>
                           
                         </form>
                        </mat-card-content>
                    </mat-card>
                    
                </mat-step>
                <mat-step label="Datos Laborales" state="laboral">

                    <mat-card>

                        <mat-card-content>

                            <div class="form-section-title">
                                Experiencia Laboral
                            </div>
                            <form [formGroup]="datosLaboralesForm">
                            <div class="mt-2">
                                <label id="example-radio-group-label"> <b style="font-size: 0.8rem;">¿Trabaja?</b> </label>
                            </div>

                            <div>
                                <mat-radio-group [formControl]="trabajaForm">
                                    <mat-radio-button  value="True" [checked]="true" >Sí</mat-radio-button>
                                    <mat-radio-button value="False"  >No</mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <button class="button-principal mt-2" mat-raised-button
                                (click)="empleoModal(ExperienciaLaboralTemplate)"
                                [disabled]="trabajaForm.value == 'False'"
                                [class.btn-empleo-disabled]="trabajaForm.value == 'False'">
                                <mat-icon>add</mat-icon>
                                Agregar Experiencia Laboral
                            </button>


                            <div class="mt-2" style="font-size: 0.8rem;">

                                <p style="margin-bottom: 0px !important;">Presione "Agregar Experiencia Laboral" para
                                    poder ingresar los datos solicitados.</p>
                                <div class="table-responsive">

                                    <table class="table table-striped bordeTabla tablep" role="table">
                                        <thead class="theadp">

                                            <tr class="trp bg-success text-center">
                                                <th  style="display: none;" class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader"></th>
                                                <th class="thp" scope="col" role="columnheader">Tipo de institución</th>
                                                <th class="thp" scope="col" role="columnheader">Área de trabajo</th>
                                                <th class="thp" scope="col" role="columnheader">Institución</th>
                                                <th class="thp" scope="col" role="columnheader">Fecha</th>
                                                <th class="thp" scope="col" role="columnheader">Horario de trabajo</th>
                                                <th class="thp" scope="col" role="columnheader">Horario que dispone para las clases</th>
                                            </tr>
                                        </thead>


                                        <tbody role="rowgroup" class="tbodyp" *ngIf="contadorTrab <= 3">

                                            <tr class="text-center trp" role="row" *ngFor="let item of empleosArray;let indiceT = index">
                                                <td  style="display: none;">{{ indiceT}}</td>
                                                <td role="cell" data-title="" class="tdp">
                                                    <button mat-mini-fab (click)="eliminarDatosLaborales(item,indiceT)" class="btn-delete" matTooltip="Borrar"  matTooltipPosition="below">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                    <button mat-mini-fab (click)="editarDatosLaborales(item, indiceT)" class="btn-edit" matTooltip="Editar"  matTooltipPosition="below">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                                <td role="cell" data-title="Tipo de institución" class="tdp">
                                                    {{item.nombreTipoInstitucion}}
                                                </td>
                                                <td role="cell" data-title="Área de trabajo" class="tdp">
                                                    {{item.areaTrabajo}}
                                                </td>
                                                <td role="cell" data-title="Institución" class="tdp">
                                                    {{item.institucion}}</td>
                                                <td role="cell" data-title="Fecha" class="tdp">{{item.anoIngresoLaborar}}</td>
                                                <td role="cell" data-title="Horario de trabajo" class="tdp">{{item.horarioLaboral
                                                    }}</td>
                                                <td role="cell" data-title="Horario clases" class="tdp">
                                                    {{item.horarioDisponibleClases
                                                    }}</td>

                                            </tr>

                                        </tbody>
                                    </table>

                                </div>
                            </div>

                            <div class="step-footer">
                                <button mat-button matStepperPrevious class="btn-volver">
                                    <mat-icon>arrow_back</mat-icon>
                                    Volver
                                </button>
                                <button mat-raised-button matStepperNext class="btn-siguiente"
                                    (click)="confirmarDatosLaborales()">
                                    Siguiente
                                    <mat-icon>arrow_forward</mat-icon>
                                </button>
                            </div>
                            </form>
                        </mat-card-content>
                    </mat-card>




                    <!-- <div
                        style="letter-spacing: -0.025em !important; line-height: 2rem !important; font-size: 1.2rem !important; font-weight: 600 !important;">
                        Experiencia Laboral
                    </div>

                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-4" *ngFor="let item of empleosArray.controls">
                            <ng-container [formGroup]="item">
                                <mat-form-field appearance="legacy">
                                    <mat-label>Institución</mat-label>
                                    <input autocomplete="off" matInput placeholder="Institución"
                                        formControlName="institucion">
                                </mat-form-field>
                            </ng-container>
                        </div>
                    </div> -->


                    <!-- <div
                        style="letter-spacing: -0.025em !important; line-height: 2rem !important; font-size: 1.2rem !important; font-weight: 600 !important;">
                        Referencias Profesionales
                    </div>

                    <div *ngFor="let item of referenciasArray.controls">

                        <ng-container [formGroup]="item">

                            <div class="row">
                                <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                    <mat-label>Nombre</mat-label>
                                    <input autocomplete="off" matInput placeholder="Nombre" formControlName="nombre">
                                </mat-form-field>
                                <mat-form-field appearance="legacy" class="col-lg-6 col-md-6 col-sm-6">
                                    <mat-label>Numero Telefono</mat-label>
                                    <input autocomplete="off" matInput placeholder="Numero Telefono"
                                        formControlName="numeroTelefono">
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </div> -->


                </mat-step>
                <mat-step label="Postulación" state="postulacion" [stepControl]="datosPostulacion">
                    <mat-card>

                        <mat-card-content>

                            <div class="form-section-title">
                                Información Postulación
                            </div>
                            <form [formGroup]="datosPostulacion">

                                <div class="row" style="font-size: 0.9rem;">
                                    <mat-form-field appearance="outline" class="col-lg-4 col-md-4 col-sm-6">
                                        <mat-label>Razón de postulación</mat-label>
                                        <textarea matInput formControlName="razonesPostulacion" cdkTextareaAutosize
                                            cdkAutosizeMinRows="6" required maxlength="300"> </textarea>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="col-lg-4 col-md-4 col-sm-6">
                                        <mat-label>¿De qué manera financiará su posgrado?</mat-label>
                                        <textarea matInput formControlName="maneraFinanciacionPosgrado" cdkTextareaAutosize
                                            cdkAutosizeMinRows="6" required></textarea>

                                        <mat-hint maxlength="300">(Fondos propios, préstamo, beca, otro)</mat-hint>

                                    </mat-form-field>


                                    <mat-form-field appearance="outline" class="col-lg-4 col-md-4 col-sm-6">
                                        <mat-label>¿Cuenta con horas disponibles para atender actividades del posgrado? 
                                        </mat-label>
                                        <textarea matInput formControlName="cuentaTiempoAtenderPosgrado" cdkTextareaAutosize
                                            cdkAutosizeMinRows="6" required maxlength="300"></textarea>
                                        <mat-hint>Extra a clases como (conferencias, investigaciones, visitas de campo
                                            etc.)</mat-hint>
                                    </mat-form-field>

                                </div>

                                <div class="row mt-2" style="font-size: 0.9rem;">
                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="mt-2">
                                            <label id="example-radio-group-label"> <b>¿Cuenta con publicaciones? <span class="titleRequired">*</span> </b>
                                            </label>
                                        </div>

                                        <mat-radio-group formControlName="cuentaConPublicaciones" class="col-md-12" (change)="onCuentaConPublicacionesChange($event)">
                                            <mat-radio-button value="True">Sí</mat-radio-button>
                                            <mat-radio-button value="False">No</mat-radio-button>
                                        </mat-radio-group>

                                        <mat-form-field appearance="legacy" class="col-md-12">
                                            <mat-label>Experiencia en publicaciones</mat-label>
                                            <textarea matInput formControlName="experienciaPublicacion"
                                                cdkTextareaAutosize cdkAutosizeMinRows="3" maxlength="250"></textarea>
                                                <mat-hint>Descripción de las 3 últimas publicaciones</mat-hint>
                                        </mat-form-field>

                                    </div>

                                    <div class="col-lg-6 col-md-6 col-sm-12">
                                        <div class="mt-2">
                                            <label id="example-radio-group-label"> <b>¿Cuenta con experiencia previa en
                                                    investigación ? <span class="titleRequired">*</span></b> </label>
                                        </div>

                                        <mat-radio-group formControlName="experienciapreviaInvestigacion" class="col-md-12" (change)="onExperienciaPreviaInvestigacionChange($event)">
                                            <mat-radio-button value="True">Sí</mat-radio-button>
                                            <mat-radio-button value="False">No</mat-radio-button>
                                        </mat-radio-group>

                                        <mat-form-field appearance="legacy" class="col-md-12">
                                            <mat-label>Descripción de experiencia</mat-label>
                                            <textarea matInput formControlName="experiencaInvestigacion"
                                                cdkTextareaAutosize cdkAutosizeMinRows="3" maxlength="250"></textarea>
                                        </mat-form-field>

                                    </div>
                                </div>
                            <!--
                                <div class="row mt-2">
                                    <div class="col-lg-4 col-md-4 col-sm-6">
                                        <div class="mt-2">
                                            <label id="example-radio-group-label"> <b>¿Ha cursado alguna vez un curso en
                                                    línea? <span class="titleRequired">*</span></b> </label>
                                        </div>

                                        <mat-radio-group formControlName="haCursadoClasesenLinea">
                                            <mat-radio-button value="True">Si</mat-radio-button>
                                            <mat-radio-button value="False">No</mat-radio-button>
                                        </mat-radio-group>
                                    </div>

                                    <div class="col-lg-4 col-md-4 col-sm-6">
                                        <div class="mt-2">
                                            <label id="example-radio-group-label"> <b>¿Ha cursado una asignatura donde
                                                    el docente se apoya en una plataforma virtual? <span class="titleRequired">*</span></b> </label>
                                        </div>

                                        <mat-radio-group formControlName="cursadoAsignaturaDocenteApoyaPlataformaVirtual">
                                            <mat-radio-button value="True">Si</mat-radio-button>
                                            <mat-radio-button value="False">No</mat-radio-button>
                                        </mat-radio-group>
                                    </div>

                                    <div class="col-lg-4 col-md-4 col-sm-6">
                                        <div class="mt-2">
                                            <label id="example-radio-group-label"> <b>¿Ha manejado el programa Microsoft
                                                    Project? <span class="titleRequired">*</span></b> </label>
                                        </div>

                                        <mat-radio-group formControlName="haManejadoProgramaMicrosoftProject">
                                            <mat-radio-button value="True">Si</mat-radio-button>
                                            <mat-radio-button value="False">No</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                </div>
                            -->    
                            </form>
                        </mat-card-content>
                        <div class="step-footer">
                            <button mat-button matStepperPrevious class="btn-volver">
                                <mat-icon>arrow_back</mat-icon>
                                Volver
                            </button>
                            <button mat-raised-button class="btn-siguiente"
                                (click)="guardarPostulacion()">
                                Siguiente
                                <mat-icon>arrow_forward</mat-icon>
                            </button>
                        </div>
                    </mat-card>
                </mat-step>
                <mat-step label="Enviar Solicitud" state="Enviar">
                    <mat-card>
                      <mat-card-content>

                        <!-- Header del paso -->
                        <div class="enviar-header">
                          <div class="enviar-icon-wrap">
                            <mat-icon>assignment_turned_in</mat-icon>
                          </div>
                          <div class="enviar-texts">
                            <h4 class="enviar-title">Verifique sus datos</h4>
                            <p class="enviar-subtitle">Revise la información antes de enviar su solicitud de admisión</p>
                          </div>
                        </div>

                        <div class="cards-container" [ngClass]="{'justify-center': orientaciones.length === 0}">

                          <!-- SELECT SOLO SI HAY ORIENTACIONES -->
                          <ng-container *ngIf="orientaciones.length > 0">
                            <div class="card-orientacion">
                              <div class="resumen-card-header">
                                <mat-icon>school</mat-icon>
                                <span>Orientación</span>
                              </div>
                              <p class="orientacion-desc">Selecciona a qué orientación de la carrera deseas postular</p>
                              <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Seleccione una orientación</mat-label>
                                <mat-select [(ngModel)]="orientacionSeleccionada">
                                  <mat-option *ngFor="let o of orientaciones" [value]="o.idOrientacion">
                                    {{ o.orientacion }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div *ngIf="orientacionSeleccionada" class="orientacion-seleccionada">
                                <mat-icon>check_circle</mat-icon>
                                <span><strong>{{ orientacionSeleccionadaNombre }}</strong></span>
                              </div>
                            </div>
                          </ng-container>

                          <!-- INFORMACIÓN RESUMEN -->
                          <div class="card-informacion">
                            <div class="resumen-card-header">
                              <mat-icon>summarize</mat-icon>
                              <span>Resumen de solicitud</span>
                            </div>
                            <ul class="resumen-list">
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">foundation</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Centro</span>
                                  <span class="resumen-value">{{centroVirtual}}</span>
                                </div>
                              </li>
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">menu_book</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Posgrado</span>
                                  <span class="resumen-value">{{datosCarrera.nombrePosgrado}}</span>
                                </div>
                              </li>
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">person</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Nombre completo</span>
                                  <span class="resumen-value">
                                    {{datosPersonalesForm.value.primerNombre}} {{datosPersonalesForm.value.segundoNombre}}
                                    {{datosPersonalesForm.value.primerApellido}} {{datosPersonalesForm.value.segundoApellido}}
                                  </span>
                                </div>
                                <button mat-icon-button (click)="goToDatosGenerales(stepper)" class="resumen-edit-btn" matTooltip="Editar datos">
                                  <mat-icon>edit</mat-icon>
                                </button>
                              </li>
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">badge</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Número de identificación</span>
                                  <span class="resumen-value">{{datosPersonalesForm.value.noIdentificacion}}</span>
                                </div>
                                <button mat-icon-button (click)="goToDatosGenerales(stepper)" class="resumen-edit-btn" matTooltip="Editar datos">
                                  <mat-icon>edit</mat-icon>
                                </button>
                              </li>
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">email</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Correo electrónico</span>
                                  <span class="resumen-value">{{datosPersonalesForm.value.correoElectronico}}</span>
                                </div>
                                <button mat-icon-button (click)="goToDatosGenerales(stepper)" class="resumen-edit-btn" matTooltip="Editar datos">
                                  <mat-icon>edit</mat-icon>
                                </button>
                              </li>
                              <li class="resumen-item">
                                <mat-icon class="resumen-icon">phone_android</mat-icon>
                                <div class="resumen-data">
                                  <span class="resumen-label">Teléfono celular</span>
                                  <span class="resumen-value">{{datosPersonalesForm.value.celularContacto}}</span>
                                </div>
                                <button mat-icon-button (click)="goToDatosGenerales(stepper)" class="resumen-edit-btn" matTooltip="Editar datos">
                                  <mat-icon>edit</mat-icon>
                                </button>
                              </li>
                            </ul>
                          </div>

                        </div>
                      </mat-card-content>

                      <!-- Botones -->
                      <div class="step-footer">
                        <button mat-button matStepperPrevious class="btn-volver">
                          <mat-icon>arrow_back</mat-icon>
                          Volver
                        </button>
                        <button *ngIf="orientaciones.length === 0 || orientacionSeleccionada"
                                mat-raised-button
                                class="btn-enviar"
                                [disabled]="(fichaAdmisionFacade.responseCargando$ | async)"
                                (click)="guardarSolicitud()">
                          {{ (fichaAdmisionFacade.responseCargando$ | async) ? 'Enviando...' : 'Enviar solicitud' }}
                          <mat-icon *ngIf="!(fichaAdmisionFacade.responseCargando$ | async)">send</mat-icon>
                        </button>
                      </div>
                    </mat-card>
                  </mat-step>

                <!-- <mat-step label="Enviar Solicitud" state="Enviar">
                    <mat-card>

                        <mat-card-content>

                            <div  *ngIf="orientaciones.length === 0; else mostrarSelect"
                                style="letter-spacing: -0.025em !important; line-height: 2rem !important; font-size: 1.2rem !important; font-weight: 600 !important; margin-bottom: 2em;">
                                 Verifique que sus datos sean correctos
                            </div>
                            

   <ng-template #mostrarSelect>
    <mat-form-field appearance="fill" class="w-100 mb-3">
      <mat-label>Seleccione una orientación</mat-label>
      <mat-select [(ngModel)]="orientacionSeleccionada">
        <mat-option *ngFor="let o of orientaciones" [value]="o.idOrientacion">
          {{ o.orientacion }}
        </mat-option>
      </mat-select>
    </mat-form-field>
</ng-template>

                            <div class="container mt-5">
                                <div class="row justify-content-center">
                                  <div class="col-lg-6 col-md-8 col-sm-12 contact-info">
                                    <h2 class="text-center mb-4">Información previa de su solicitud</h2>
                                    <ul class="list-group with-lines" style="font-weight: 500; font-size: 1.2em;">
                                      <li class="list-group-item">
                                         <strong>Centro:</strong> {{centroVirtual}}
                                      </li>
                                      <li class="list-group-item">
                                        <strong>Posgrado:</strong> {{datosCarrera.nombrePosgrado}}
                                      </li>
                                      <li class="list-group-item">
                                        <strong>Nombre:</strong> {{datosPersonalesForm.value.primerNombre}} {{datosPersonalesForm.value.segundoNombre}}
                                        {{datosPersonalesForm.value.primerApellido}} {{datosPersonalesForm.value.segundoApellido}}
                                        <button  mat-mini-fab (click)="goToDatosGenerales(stepper)" class=" btn-edit small-button " matTooltip="Editar"  matTooltipPosition="below">
                                            <mat-icon>edit</mat-icon>
                                      </button>
                                      </li>
                                      <li class="list-group-item">
                                        <strong>Número Identificación:</strong> {{datosPersonalesForm.value.noIdentificacion}}
                                        <button  mat-mini-fab (click)="goToDatosGenerales(stepper)" class=" btn-edit small-button " matTooltip="Editar"  matTooltipPosition="below">
                                            <mat-icon>edit</mat-icon>
                                      </button>
                                      </li>
                                      <li class="list-group-item">
                                        <strong>Email:</strong> {{datosPersonalesForm.value.correoElectronico}}
                                        <button  mat-mini-fab (click)="goToDatosGenerales(stepper)" class=" btn-edit small-button " matTooltip="Editar"  matTooltipPosition="below">
                                            <mat-icon>edit</mat-icon>
                                      </button>
                                      </li>
                                      <li class="list-group-item">
                                        <strong>Teléfono:</strong> {{datosPersonalesForm.value.celularContacto}}
                                        <button  mat-mini-fab (click)="goToDatosGenerales(stepper)" class=" btn-edit small-button " matTooltip="Editar"  matTooltipPosition="below">
                                            <mat-icon>edit</mat-icon>
                                      </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                          
                          
                        </mat-card-content>
                        <div class="text-right">
                            <button mat-button matStepperPrevious>Volver</button>
                            
                        <button class="button-principal mt-2" mat-raised-button 
                        (click)="guardarSolicitud()">
                        Enviar</button>

                        </div>
                    </mat-card>


                </mat-step> -->

                <ng-template matStepperIcon="personal">
                    <mat-icon>person</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="academico">
                    <mat-icon>school</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="laboral">
                    <mat-icon>work</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="postulacion">
                    <mat-icon>auto_stories</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="Enviar">
                    <mat-icon>send</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="done">
                    <mat-icon>check</mat-icon>
                </ng-template>
                <ng-template matStepperIcon="edit">
                    <mat-icon>edit</mat-icon>
                </ng-template>

            </mat-horizontal-stepper >
        </section>
        <!-- #about -->

        <section id="requisitos-postulacion" *ngIf="solicitudEnviada && mostrarRequisitosPostulacion" class="container mt-4">
            <mat-card>
                <mat-card-content>

                    <div class="enviar-header">
                        <div class="enviar-icon-wrap">
                            <mat-icon>content_paste</mat-icon>
                        </div>
                        <div class="enviar-texts">
                            <h4 class="enviar-title">Requisitos de Postulación</h4>
                            <p class="enviar-subtitle">Su solicitud fue enviada. Suba los documentos solicitados para completar su postulación.</p>
                        </div>
                    </div>

                    <div class="alert alert-info mt-2">
                        Complete y suba los documentos solicitados a continuación. Guarde el correo
                        <b>{{datosPersonalesForm.value.correoElectronico}}</b>
                        con el que se postuló, ya que más adelante lo necesitará para darle seguimiento a su solicitud.
                    </div>

                    <div class="alert alert-warning mt-2" style="display: flex; align-items: center; gap: 10px;">
                        <mat-icon style="flex-shrink: 0;">mark_email_read</mat-icon>
                        <span>
                            Le enviamos un correo a <b>{{datosPersonalesForm.value.correoElectronico}}</b> con el
                            acceso para continuar subiendo estos documentos más adelante, por si no logra
                            completarlos en este momento.
                        </span>
                    </div>

                    <p *ngIf="postulacionInfo?.nombreProceso" class="mt-2" style="margin-bottom: 0;">
                        Proceso de admisión: <b>{{postulacionInfo?.nombreProceso}}</b>
                    </p>

                    <div class="mt-2" *ngFor="let requisito of requisitosAgrupados; trackBy: trackByRequisito"
                        style="border: 1px solid #dee2e6; border-radius: 6px; padding: 12px; margin-bottom: 12px;">

                        <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap;">
                            <div>
                                <b>{{requisito.nombreRequisito}}</b>
                                <span *ngIf="requisito.obligatorio" class="titleRequired">*</span>
                                <p *ngIf="requisito.descripcionRequisito" style="margin-bottom: 0;">
                                    {{requisito.descripcionRequisito}}
                                </p>
                            </div>
                            <span [ngClass]="claseEstadoRequisito(requisito.estadoRequisito)">{{requisito.estadoRequisito}}</span>
                        </div>

                        <div class="table-responsive mt-2">
                            <table class="table table-striped bordeTabla tablep" role="table">
                                <thead class="theadp">
                                    <tr class="trp bg-success text-center">
                                        <th class="thp" scope="col" role="columnheader">Obligatorio</th>
                                        <th class="thp" scope="col" role="columnheader">Entregable</th>
                                        <th class="thp" scope="col" role="columnheader">Estado</th>
                                        <th class="thp" scope="col" role="columnheader">Documento</th>
                                        <th class="thp" scope="col" role="columnheader">Observaciones</th>
                                    </tr>
                                </thead>

                                <tbody role="rowgroup" class="tbodyp">
                                    <tr class="text-center trp" role="row"
                                        *ngFor="let detalle of requisito.detalles; trackBy: trackByDetalle">
                                        <td role="cell" data-title="Obligatorio" class="tdp">
                                            {{ detalle.obligatorio ? 'Sí' : 'No' }}
                                        </td>
                                        <td role="cell" data-title="Entregable" class="tdp">
                                            {{detalle.nombreDetalle}}
                                            <span *ngIf="detalle.obligatorio" class="titleRequired">*</span>
                                        </td>
                                        <td role="cell" data-title="Estado" class="tdp">
                                            <span [ngClass]="claseEstadoRequisito(detalle.estadoRequisito)">{{detalle.estadoRequisito}}</span>
                                        </td>
                                        <td role="cell" data-title="Documento" class="tdp">
                                            <ng-container *ngIf="detalle.requiereDocumento; else sinDocumento">
                                                <div *ngIf="!detalle.rutaDocumento">
                                                    <button mat-stroked-button color="primary" type="button"
                                                        (click)="abrirModalDocumentoRequisito(detalle)">
                                                        <mat-icon>upload_file</mat-icon>
                                                        Subir
                                                    </button>
                                                </div>
                                                <div *ngIf="detalle.rutaDocumento">
                                                    <button mat-icon-button color="primary" type="button"
                                                        matTooltip="Ver / reemplazar documento" (click)="abrirModalDocumentoRequisito(detalle)">
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>
                                                    <button mat-icon-button color="warn" type="button"
                                                        matTooltip="Quitar documento" (click)="eliminarDocumentoRequisito(detalle)">
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </div>
                                            </ng-container>
                                            <ng-template #sinDocumento>N/A</ng-template>
                                        </td>
                                        <td role="cell" data-title="Observaciones" class="tdp">{{detalle.observaciones}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </mat-card-content>
                <div class="step-footer">
                    <button mat-raised-button class="btn-enviar" (click)="continuarPostulacion()">
                        Continuar 
                        <mat-icon>check</mat-icon>
                    </button>
                </div>
            </mat-card>
        </section>

        <!--==========================
      Services Section
    ============================-->
        <!-- <p class="description">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eaque ratione, ab eligendi optio ducimus dolorem praesentium doloribus a ad aperiam</p> -->
        <!-- <section id="services" class="section-bg">
            <div class="container">

                <header class="section-header">
                    <h3>Servicios</h3>
                    <p>La Universidad Nacional Autónoma de Honduras (UNAH) pone a disposición los servicios que estaran disponibles en los centros universitarios.</p>
                </header>

                <div class="row">

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Homologación</a></h4>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Validación Titulos</a></h4>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Solvencia de Matricula</a></h4>
                            
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-bookmarks-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Operaciones Múltiples</a></h4>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-5 offset-lg-1 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color: #004A99;"></i></div>
                            <h4 class="title"><a>Certificación de Estudios</a></h4>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 wow bounceInUp" data-wow-delay="0.1s" data-wow-duration="1.4s">
                        <div class="box">
                            <div class="icon"><i class="ion-ios-paper-outline" style="color:#004A99;"></i></div>
                            <h4 class="title"><a [routerLink]="['/reservacion/centros-regionales']">Ver otros servicios</a></h4>
                        </div>
                    </div>

                </div>

            </div>
        </section> -->
        <!-- #services -->


    </main>



</body>

<ng-template #EducacionTemplate>
    <div class="modal-dsep-header">
        <div class="modal-dsep-icon"><mat-icon>school</mat-icon></div>
        <div class="modal-dsep-titles">
            <h4 class="modal-dsep-title">Formación Académica</h4>
            <span class="modal-dsep-subtitle">Complete los datos de su educación superior</span>
        </div>
    </div>
    <mat-dialog-content class="modal-dsep-content">
        <form [formGroup]="datosAcademicosForm">
            <div class="row">
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-3">
                    <mat-label>Grado académico</mat-label>
                    <mat-select formControlName="idGradoAcademico" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table11" value="{{item.id}}" (click)="datosAcademicosForm.get('nombreGradoAcademico').setValue(item.nombreGradoAcademico)">
                            {{item.nombreGradoAcademico}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-4">
                    <mat-label>Título</mat-label>
                    <input autocomplete="off" matInput placeholder="Titulo" formControlName="titulo" required maxlength="100">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-3">
                    <mat-label>Institución</mat-label>
                    <mat-select formControlName="institucion" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table4" value="{{item.idUniversidad}}" (click)="datosAcademicosForm.get('nombreInstitucion').setValue(item.universidad)">
                            {{item.universidad}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Año de graduación</mat-label>
                    <input (paste)="disablePaste($event)" (keypress)="validateNumber($event)" autocomplete="off" matInput formControlName="anoGraducion" required maxlength="4">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Índice de graduación</mat-label>
                    <input type="number" autocomplete="off" matInput formControlName="indiceGraduacion" min=0 max=100 oninput="javascript: if (this.value > 100 || this.value < 0) this.value = this.value.slice(0, this.value.length - 1); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" required>
                    <span matSuffix>%</span>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Duración de estudios</mat-label>
                    <input autocomplete="off" matInput placeholder="Duración de estudios" formControlName="duracionEstudio" required maxlength="15">
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <div class="modal-dsep-footer">
        <button mat-button class="btn-modal-cancel" mat-dialog-close (click)="salir()">
            <mat-icon>close</mat-icon> Cancelar
        </button>
        <button mat-raised-button class="btn-modal-save" (click)="guardarDatosAcademicos()">
            <mat-icon>save</mat-icon> Guardar
        </button>
    </div>
</ng-template>


<ng-template #IdiomaTemplate>
    <div class="modal-dsep-header">
        <div class="modal-dsep-icon"><mat-icon>translate</mat-icon></div>
        <div class="modal-dsep-titles">
            <h4 class="modal-dsep-title">Idiomas</h4>
            <span class="modal-dsep-subtitle">Califique del 1 (más bajo) al 5 (más alto)</span>
        </div>
    </div>
    <mat-dialog-content class="modal-dsep-content">
        <form [formGroup]="lenguajeForm">
            <div class="row">
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Idioma</mat-label>
                    <mat-select formControlName="idIdioma" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table5" value="{{item.id}}" (click)="lenguajeForm.get('idioma').setValue(item.nombreIdioma)">
                            {{item.nombreIdioma}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Comprende</mat-label>
                    <mat-select formControlName="comprende" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table6" value="{{item.id}}" (click)="lenguajeForm.get('nombreComprende').setValue(item.puntuacion)">
                            {{item.nombreNivel}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Habla</mat-label>
                    <mat-select formControlName="habla" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table6" value="{{item.id}}" (click)="lenguajeForm.get('nombrehabla').setValue(item.puntuacion)">
                            {{item.nombreNivel}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Lee</mat-label>
                    <mat-select formControlName="lee" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table6" value="{{item.id}}" (click)="lenguajeForm.get('nombreLee').setValue(item.puntuacion)">
                            {{item.nombreNivel}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Escribe</mat-label>
                    <mat-select formControlName="escribe" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table6" value="{{item.id}}" (click)="lenguajeForm.get('nombreEscribe').setValue(item.puntuacion)">
                            {{item.nombreNivel}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <div class="modal-dsep-footer">
        <button mat-button class="btn-modal-cancel" mat-dialog-close (click)="salir()">
            <mat-icon>close</mat-icon> Cancelar
        </button>
        <button mat-raised-button class="btn-modal-save" (click)="guardarIdioma()">
            <mat-icon>save</mat-icon> Guardar
        </button>
    </div>
</ng-template>


<ng-template #OtrosEstudiosTemplate>
    <div class="modal-dsep-header">
        <div class="modal-dsep-icon"><mat-icon>auto_stories</mat-icon></div>
        <div class="modal-dsep-titles">
            <h4 class="modal-dsep-title">Otros Estudios</h4>
            <span class="modal-dsep-subtitle">Diplomados, capacitaciones o cursos recientes</span>
        </div>
    </div>
    <mat-dialog-content class="modal-dsep-content">
        <form [formGroup]="otrosEstudiosForm">
            <div class="row">
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Tipo de estudio</mat-label>
                    <mat-select formControlName="idTipoEstudio" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table7" value="{{item.idTipoOtroEstudio}}" (click)="otrosEstudiosForm.get('nombreTipoEstudio').setValue(item.tipoEstudio)">
                            {{item.tipoEstudio}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Título</mat-label>
                    <input autocomplete="off" matInput formControlName="titulo" required maxlength="100">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Institución</mat-label>
                    <input autocomplete="off" matInput formControlName="institucion" required maxlength="100">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Año que lo obtuvo</mat-label>
                    <input (paste)="disablePaste($event)" autocomplete="off" matInput formControlName="anoObtencion" (keypress)="validateNumber($event)" required maxlength="4">
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <div class="modal-dsep-footer">
        <button mat-button class="btn-modal-cancel" mat-dialog-close (click)="salir()">
            <mat-icon>close</mat-icon> Cancelar
        </button>
        <button mat-raised-button class="btn-modal-save" (click)="guardarOtrosEstudios()">
            <mat-icon>save</mat-icon> Guardar
        </button>
    </div>
</ng-template>



<ng-template #ExperienciaLaboralTemplate>
    <div class="modal-dsep-header">
        <div class="modal-dsep-icon"><mat-icon>work</mat-icon></div>
        <div class="modal-dsep-titles">
            <h4 class="modal-dsep-title">Experiencia Laboral</h4>
            <span class="modal-dsep-subtitle">Ingrese los datos de su empleo actual</span>
        </div>
    </div>
    <mat-dialog-content class="modal-dsep-content">
        <form [formGroup]="datosLaboralesForm">
            <div class="row">
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Tipo de institución laboral</mat-label>
                    <mat-select formControlName="idTipoInstitucion" required>
                        <mat-option *ngFor="let item of (fichaAdmisionFacade.responseDatosGenerales$ | async)?.Table8" value="{{item.idTipoInstitucion}}" (click)="datosLaboralesForm.get('nombreTipoInstitucion').setValue(item.tipoInstitucion)">
                            {{item.tipoInstitucion}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Institución</mat-label>
                    <input autocomplete="off" matInput placeholder="Institución" formControlName="institucion" required maxlength="100">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Área de trabajo</mat-label>
                    <input autocomplete="off" matInput placeholder="Área Trabajo" formControlName="areaTrabajo" required maxlength="100">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Año que ingresó a laborar</mat-label>
                    <input (paste)="disablePaste($event)" autocomplete="off" matInput formControlName="anoIngresoLaborar" (keypress)="validateNumber($event)" required maxlength="4">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Horario laboral</mat-label>
                    <input autocomplete="off" matInput formControlName="horarioLaboral" maxlength="35">
                </mat-form-field>
                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <mat-label>Horario disponible</mat-label>
                    <input autocomplete="off" matInput formControlName="horarioDisponibleClases" maxlength="35">
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>
    <div class="modal-dsep-footer">
        <button mat-button class="btn-modal-cancel" mat-dialog-close (click)="salir()">
            <mat-icon>close</mat-icon> Cancelar
        </button>
        <button mat-raised-button class="btn-modal-save" (click)="guardarEmpleo()">
            <mat-icon>save</mat-icon> Guardar
        </button>
    </div>
</ng-template>

<!-- Modal para subir/reemplazar el documento de un requisito de postulación -->
<ng-template #documentoRequisitoTemplate>
    <div class="modal-dsep-header">
        <div class="modal-dsep-icon"><mat-icon>description</mat-icon></div>
        <div class="modal-dsep-titles">
            <h4 class="modal-dsep-title">{{ detalleSeleccionado?.nombreDetalle }}</h4>
            <span class="modal-dsep-subtitle">Formatos: PDF, JPG, PNG — Máximo 25 MB</span>
        </div>
    </div>
    <mat-dialog-content class="modal-dsep-content">

        <div class="documento-cargando" *ngIf="cargandoPreviewRequisito">
            <mat-spinner diameter="32"></mat-spinner>
            <p>Cargando documento...</p>
        </div>

        <div class="documento-preview-box" *ngIf="(isImageRequisito || isPdfRequisito) && !cargandoPreviewRequisito">
            <img *ngIf="isImageRequisito && previewUrlRequisito" [src]="previewUrlRequisito" class="documento-preview-img" alt="Vista previa"/>
            <embed *ngIf="isPdfRequisito && safePreviewUrlRequisito" [src]="safePreviewUrlRequisito" type="application/pdf" class="documento-preview-pdf"/>
        </div>

        <div class="documento-upload-zone" *ngIf="!cargandoPreviewRequisito">
            <label for="archivoModalRequisito" class="documento-upload-label">
                <mat-icon>cloud_upload</mat-icon>
                <span>{{ detalleSeleccionado?.rutaDocumento ? 'Selecciona un archivo para reemplazarlo' : 'Selecciona un archivo' }}</span>
            </label>
            <input type="file" id="archivoModalRequisito" class="documento-upload-input"
                accept=".pdf,.jpg,.jpeg,.png"
                (change)="onArchivoModalSeleccionado($event)" />
        </div>

    </mat-dialog-content>
    <div class="modal-dsep-footer">
        <button mat-button class="btn-modal-cancel" (click)="cerrarModalDocumentoRequisito()">
            <mat-icon>close</mat-icon> Cerrar
        </button>
        <button mat-raised-button class="btn-modal-save" *ngIf="archivoSeleccionadoRequisito"
            [disabled]="guardandoDocumentoRequisito"
            (click)="guardarDocumentoRequisitoModal()">
            <mat-icon>save</mat-icon>
            {{ guardandoDocumentoRequisito ? 'Guardando...' : (detalleSeleccionado?.rutaDocumento ? 'Actualizar' : 'Guardar documento') }}
        </button>
    </div>
</ng-template>

<!--modal debo retirar una vez la pase a una pagina-->
<!--
<ng-template #DatosSolicitudTemplate>
    <div class="matCardHeader " style="font-size: 1.2rem; text-align:center"  >
        Solicitud de Admisión
    </div>
    <mat-dialog-content class="mat-typography" style="height: 100% !important; padding: 10px !important;">
        <form [formGroup]="datosSolicitudForm">
            <div
            style="letter-spacing: -0.025em !important; line-height: 2rem !important; margin-bottom: 30px; font-size: 1.1rem !important; font-weight: 600 !important;">
            Verifique que la información proporcionada esta correcta
        </div>
            <div class="row">

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-4">
                    <label>Nombre:</label>
                    <input type="text" autocomplete="off" matInput  formControlName="Nombre"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-4">
                    <label>Número Identificación:</label>
                    <input type="text" autocomplete="off" matInput  formControlName="NumeroIdentificación"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-4">
                    <label>Género:</label>
                    <input type="text" autocomplete="off" matInput  formControlName="Genero"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-6 col-sm-4">
                    <label>Número Cuenta:</label>
                    <input type="text" autocomplete="off" matInput  formControlName="NumeroCuenta"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <label>Correo Electrónico:</label>
                    <input type="text" autocomplete="off" matInput formControlName="Correo"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <label>Teléfono Celular:</label>
                    <input type="text" autocomplete="off" matInput formControlName="TelefonoCelular"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <label>Nacionalidad:</label>
                    <input type="text" autocomplete="off" matInput formControlName="Nacionalidad"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <label>Lugar Nacimiento:</label>
                    <input type="text" autocomplete="off" matInput formControlName="LugarNacimiento"  disabled>
                </mat-form-field>

                <mat-form-field appearance="legacy" class="col-lg-4 col-md-4 col-sm-4">
                    <label>Dirección de Residencia:</label>
                    <input type="text"  autocomplete="off" matInput  formControlName="Residencia"  disabled>
                </mat-form-field>

            </div>
        </form>
    </mat-dialog-content>

    <div class="text-right" style="margin-right: 10px; margin-bottom: 10px;">
        <button mat-button mat-dialog-close>Volver</button>
        <button mat-raised-button class="button-principal" (click)="guardarSolicitud()" >Enviar</button>
    </div>
</ng-template>
-->




<!-- <div>
  <header class="showcase">
    <div class="text-center content marginHeader">
      <h4 style="font-weight: bold;">Rervacion UNAH</h2>
      <div class="mt-4">
        <button mat-raised-button class="backgroundInstitucional" [routerLink]="['/reservacion/business']">Reservar</button>
      </div>
    </div>
  </header>

  <div class="text-center mt-2">
    <h1 class="title">Servicios</h1>
  </div>

  <footer>
    <div class="text-center">
      <span class="spanP">Derechos reservados Universidad Nacional Autónoma de Honduras 2020</span>
      <br>
      <div class="copyright-links spanP">
        Desarrollado por la <a style="color: #ffcc00" href="https://degt.unah.edu.hn">Dirección
          Ejecutiva de
          Gestión de Tecnología</a>
      </div>
    </div>
  </footer>

</div> -->